var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.8C23.0692 28.8 28.8 23.0693 28.8 16C28.8 8.93077 23.0692 3.20001 16 3.20001C8.93076 3.20001 3.2 8.93077 3.2 16C3.2 23.0693 8.93076 28.8 16 28.8Z",
    fill: "url(#paint0_radial_510_4536)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16 28.8C23.0692 28.8 28.8 23.0693 28.8 16C28.8 8.93077 23.0692 3.20001 16 3.20001C8.93076 3.20001 3.2 8.93077 3.2 16C3.2 23.0693 8.93076 28.8 16 28.8Z",
    fill: "url(#paint1_radial_510_4536)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.184 9.36795C13.184 8.85595 12.632 8.53595 11.672 8.53595C10.864 8.53595 9.07998 8.98395 7.85598 10.56C7.63198 10.848 7.97598 11.008 8.19998 10.824C8.95198 10.184 10.976 9.35995 12.552 9.53595C13.184 9.59995 13.184 9.36795 13.184 9.36795Z",
    fill: "url(#paint2_linear_510_4536)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.816 15.584C12.4964 15.584 13.048 14.7494 13.048 13.72C13.048 12.6905 12.4964 11.856 11.816 11.856C11.1356 11.856 10.584 12.6905 10.584 13.72C10.584 14.7494 11.1356 15.584 11.816 15.584Z",
    fill: "url(#paint3_radial_510_4536)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.816 12.488C12.344 12.488 12.808 12.952 13.048 13.632C13.032 12.624 12.488 11.816 11.816 11.816C11.144 11.816 10.6 12.624 10.584 13.632C10.824 12.952 11.288 12.488 11.816 12.488Z",
    fill: "url(#paint4_linear_510_4536)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.816 9.36795C18.816 8.85595 19.368 8.53595 20.328 8.53595C21.136 8.53595 22.92 8.98395 24.144 10.56C24.368 10.848 24.024 11.008 23.8 10.824C23.048 10.184 21.024 9.35995 19.448 9.53595C18.808 9.59995 18.816 9.36795 18.816 9.36795Z",
    fill: "url(#paint5_linear_510_4536)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.656 19.744C21.552 19.728 21.44 19.76 21.368 19.832C19.992 21.12 17.872 21.816 16.272 21.816H16H15.728C14.128 21.816 12.008 21.12 10.632 19.832C10.552 19.76 10.448 19.728 10.344 19.744C10.232 19.768 10.176 19.888 10.232 19.984C11.408 22.016 13.576 23.272 15.936 23.272H16.008H16.08C18.44 23.272 20.608 22.016 21.784 19.984C21.824 19.888 21.768 19.768 21.656 19.744Z",
    fill: "#643800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.176 15.584C20.8564 15.584 21.408 14.7494 21.408 13.72C21.408 12.6905 20.8564 11.856 20.176 11.856C19.4955 11.856 18.944 12.6905 18.944 13.72C18.944 14.7494 19.4955 15.584 20.176 15.584Z",
    fill: "url(#paint6_radial_510_4536)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.176 12.488C19.648 12.488 19.184 12.952 18.944 13.632C18.96 12.624 19.504 11.816 20.176 11.816C20.848 11.816 21.392 12.624 21.408 13.632C21.168 12.952 20.704 12.488 20.176 12.488Z",
    fill: "url(#paint7_linear_510_4536)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.656 19.744C21.552 19.728 21.44 19.76 21.368 19.832C19.992 21.12 17.8719 21.816 16.272 21.816H16H15.728C14.128 21.816 12.008 21.12 10.632 19.832C10.552 19.76 10.448 19.728 10.344 19.744C10.232 19.768 10.176 19.888 10.232 19.984C10.24 20.008 10.256 20.024 10.272 20.04C10.384 19.976 10.504 19.912 10.624 20.048C11.928 21.512 13.864 22.392 15.936 22.392H16.008H16.08C18.168 22.392 20.112 21.504 21.416 20.016C21.536 19.88 21.6479 19.944 21.7519 20.016C21.7599 20 21.768 19.992 21.776 19.976C21.824 19.888 21.768 19.768 21.656 19.744Z",
    fill: "url(#paint8_linear_510_4536)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_510_4536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4784 10.8126) scale(15.4415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_510_4536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4784 10.8126) scale(12.1485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_4536",
    x1: 10.4817,
    y1: 10.2259,
    x2: 10.4817,
    y2: 8.87711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_510_4536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4482 13.7729) rotate(73.8539) scale(1.80855 1.1701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_4536",
    x1: 11.8178,
    y1: 11.8488,
    x2: 11.8178,
    y2: 13.5859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_510_4536",
    x1: 21.5119,
    y1: 10.2259,
    x2: 21.5119,
    y2: 8.87711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_510_4536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8065 13.7732) rotate(73.8539) scale(1.80855 1.1701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_510_4536",
    x1: 20.1758,
    y1: 11.8488,
    x2: 20.1758,
    y2: 13.5859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_510_4536",
    x1: 15.9968,
    y1: 20.6488,
    x2: 15.9968,
    y2: 22.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.9ca32653a5f05b3db1c58c7d2223d522.svg";
export { ForwardRef as ReactComponent };